/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useCallback } from "react";
import "./admin.css";
import menuIcon from "../../../assets/imgs/navbar/menu-open.svg";
import menuIconClicked from "../../../assets/imgs/navbar/menu-closed.svg";
import perfilIcon from "../../../assets/imgs/dashboard-admin/perfil-icon.png";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { IoAirplane } from "react-icons/io5";
import { RiFlightTakeoffLine } from "react-icons/ri";
import {
  PiAirplaneInFlightFill,
  PiClockCounterClockwiseBold,
  PiNotePencilBold,
} from "react-icons/pi";
import { FaArrowsRotate } from "react-icons/fa6";
import { PiArrowsClockwiseBold } from "react-icons/pi";
import { RiCalendarEventFill } from "react-icons/ri";
import {
  FaUserCheck,
  FaSignOutAlt,
  FaUserCog,
  FaCog,
  FaLightbulb,
  FaMoneyCheckAlt,
  FaFileCode,
  FaProjectDiagram,
  FaServer,
  FaBalanceScale,
  FaWindows,
} from "react-icons/fa";
import { Collapse } from "react-collapse";
import MainBanner from "../../../components/dashboard/main-banner/main-banner";
import Usuarios from "./usuarios/usuarios";
import AddUser from "./usuarios/add/add-user";
import UsuariosEliminado from "./usuarios/usuarios-eliminados/usuarios-eliminado";
import Bienvenido from "./bienvenido/bienvenido";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import Swal from "sweetalert2";
import Loading from "../components/loading/loading";
import pdfQuickReference from "../../../assets/pdfs/quick_reference.pdf";
import UserNotFound from "../components/user-not-found/user-not-found";
import Domestico from "./domestico/domestico";
import Internacionales from "./internacionales/internacionales";
import LogVuelos from "./log-vuelos/log-vuelos";
import BatchCartaPorte from "./batch-carta-porte/batch-carta-porte";
import AddTarifas from "./tarifas-promedio/add-tarifas/add-tarifas";
import TarifasPromedio from "./tarifas-promedio/tarifas-promedio";
import FechaMetodos from "./fecha-metodos/fecha-metodos";

import SessionExpired from "../../../components/session-expired/session-expired";
import ReporteComat from "./comat-reporte/comat-reporte";
import ReporteVuelos from "./reporte-vuelos/reporte-vuelos";
import BatchVuelos from "./batch-vuelos/batch-vuelos";
import Vuelos from "./vuelos/vuelos";
import LogOracle from "./log-oracle/log-oracle";
import SLA from "./sla/slas";
import AddSlas from "./sla/add-slas/add-slas";
import SlasEliminado from "./sla/slas-eliminados/slas-eliminados";
import Servicios from "./servicios/servicios";
import AddServicio from "./servicios/add-servicios/add-servicio";
import RestoreServicio from "./servicios/restore-servicios/restore-servicio";
import Dashboard from "./dashboard/dashboard";
import Maintenance from "./maintenance/Maintenance";

function Admin() {
  const { user, isAuthenticated, isLoading, logout } = useAuth0();
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [imgUser, setImgUser] = useState(perfilIcon);
  const [permissions, setPermissions] = useState([]);

  const [isCheckboxCollapseOpen, setIsCheckboxCollapseOpen] = useState(false);
  const [isCheckboxCollapseOpen1, setIsCheckboxCollapseOpen1] = useState(false);
  const [isCheckboxCollapseOpen2, setIsCheckboxCollapseOpen2] = useState(false);
  const [isCheckboxCollapseOpen3, setIsCheckboxCollapseOpen3] = useState(false);
  const [isCheckboxCollapseOpen4, setIsCheckboxCollapseOpen4] = useState(false);

  const onChange = useCallback(
    ({ target: { checked } }) => setIsCheckboxCollapseOpen(checked),
    [setIsCheckboxCollapseOpen]
  );

  const onChange1 = useCallback(
    ({ target: { checked } }) => setIsCheckboxCollapseOpen1(checked),
    [setIsCheckboxCollapseOpen1]
  );

  const onChange2 = useCallback(
    ({ target: { checked } }) => setIsCheckboxCollapseOpen2(checked),
    [setIsCheckboxCollapseOpen2]
  );

  const onChange3 = useCallback(
    ({ target: { checked } }) => setIsCheckboxCollapseOpen3(checked),
    [setIsCheckboxCollapseOpen3]
  );

  const onChange4 = useCallback(
    ({ target: { checked } }) => setIsCheckboxCollapseOpen4(checked),
    [setIsCheckboxCollapseOpen4]
  );

  useEffect(() => {
    const emailRegularExpression =
      /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;

    const loginWithRetries = async (data, retries = 5) => {
      for (let attempt = 1; attempt <= retries; attempt++) {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_URL_BACKEND}/api/v1/users/login`,
            data
          );

          if (response.data.code === 1) {
            Swal.fire({
              title: "Usuario logeado exitosamente",
              icon: "success",
            });

            const data = {
              id: response.data.user.id,
              first_name: response.data.user.first_name,
              last_name: response.data.user.last_name,
              email: response.data.user.email,
              role_id: response.data.user.role_id,
            };

            localStorage.setItem("user", JSON.stringify(data));
            sessionStorage.setItem("token", response.data.user.token);
            sessionStorage.setItem(
              "tokenExpire",
              response.data.user.tokenExpiration
            );
            localStorage.setItem("username", user.nickname);
            localStorage.setItem("photo", user.picture);

            const permissions = await axios.get(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/permissions/${response.data.user.id}`,
              {
                headers: {
                  Authorization: `Bearer ${response.data.user.token}`,
                },
              }
            );

            localStorage.setItem(
              "permissions",
              JSON.stringify(permissions.data.data)
            );
            setPermissions(permissions.data.data);

            const changeLastLogin = await axios.get(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/users/changelastlogin/${response.data.user.id}`,
              {
                headers: {
                  Authorization: `Bearer ${response.data.user.token}`,
                },
              }
            );

            if (changeLastLogin.data.code === 1) {
              console.info(`Ultima sesión actualizada ${new Date()}`);
            }
            setHasFetchedData(true);
            break;
          }
        } catch (error) {
          if (attempt === retries) {
            setShowAlert(true);
            setHasFetchedData(true);
          }
        }
      }
    };

    const token = sessionStorage.getItem("token");
    const storedPermissions = localStorage.getItem("permissions");

    if (isAuthenticated && !hasFetchedData) {
      if (token && storedPermissions) {
        setPermissions(JSON.parse(storedPermissions));
        setHasFetchedData(true);
      } else {
        const email = user.email.match(emailRegularExpression);
        setImgUser(user.picture);
        const data = { email: email[0], key: process.env.REACT_APP_KEY };
        loginWithRetries(data);
      }
    }
  }, [isAuthenticated, hasFetchedData, user]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "logout") {
        // Si detecta que se hizo logout en otra pestaña
        logout({
          logoutParams: { returnTo: process.env.REACT_APP_LOGOUT_URL },
        });
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const sectionNames = {
    Usuarios: "Lista de Usuarios",
    AddUser: "Agregar Usuario",
    deleteUser: "Restaurar Usuario",
    Domestico: "Doméstico",
    Internacionales: "Internacionales",
    Batch: "Batch",
    Vuelos: "Vuelos",
    Comat: "Reporte Comat",
    FechaMetodos: "Fecha límite de métodos",
    BatchVuelos: "Batch Vuelos",
    ReporteVuelos: "Reporte Vuelos",
    LogVuelos: "Log Vuelos",
    LogOracle: "Log Oracle",
    Tarifas: "Tarifas Promedio",
    AddTarifas: "Agregar Tarifas",
    GCP: "GCP",
    VentMant: "Ventanas de Mantenimiento",
    Dashboard: "Dashboard",
    Servicios: "Servicios",
    AddServicios: "Agregar Servicios",
    RestoreServicios: "Restaurar Servicios",
    SLA: "SLA's",
    AddSLA: "Agregar SLA's",
    RestoreSLA: "Restaurar SLA's",
  };

  const getSectionIcon = (section) => {
    switch (section) {
      case "Usuarios":
        return <FaUserCheck className="fs-5 align-self-center" />;
      case "AddUser":
        return <FaUserCheck className="fs-5 align-self-center" />;
      case "deleteUser":
        return <FaUserCheck className="fs-5 align-self-center" />;
      case "Domestico":
        return <RiFlightTakeoffLine className="fs-5 align-self-center" />;
      case "Internacionales":
        return <PiAirplaneInFlightFill className="fs-5 align-self-center" />;
      case "Comat":
        return <PiNotePencilBold className="fs-5 align-self-center" />;
      case "Vuelos":
        return <IoAirplane className="fs-5 align-self-center" />;
      case "FechaMetodos":
        return <RiCalendarEventFill className="fs-5 align-self-center" />;
      case "BatchVuelos":
        return <PiArrowsClockwiseBold className="fs-5 align-self-center" />;
      case "ReporteVuelos":
        return <FaArrowsRotate className="fs-5 align-self-center" />;
      case "LogOracle":
        return (
          <PiClockCounterClockwiseBold className="fs-5 align-self-center" />
        );
      case "Tarifas":
        return <FaMoneyCheckAlt className="fs-5 align-self-center" />;
      case "AddTarifas":
        return <FaMoneyCheckAlt className="fs-5 align-self-center" />;
      case "GCP":
        return <FaFileCode className="fs-5 align-self-center" />;
      case "VentMant":
        return <FaWindows className="fs-5 align-self-center" />;
      case "Dashboard":
        return <FaProjectDiagram className="fs-5 align-self-center" />;
      case "Servicios":
        return <FaServer className="fs-5 align-self-center" />;
      case "AddServicios":
        return <FaServer className="fs-5 align-self-center" />;
      case "RestoreServicios":
        return <FaServer className="fs-5 align-self-center" />;
      case "SLA":
        return <FaBalanceScale className="fs-5 align-self-center" />;
      case "AddSLA":
        return <FaBalanceScale className="fs-5 align-self-center" />;
      case "RestoreSLA":
        return <FaBalanceScale className="fs-5 align-self-center" />;
      default:
        return null;
    }
  };

  const [selectedComponent, setSelectedComponent] = useState("");

  const handleMenuClick = (componentName) => {
    setSelectedComponent(componentName);
    closeMobileMenu();
  };

  const closeMobileMenu = () => setClick(false);
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const logoutAdmin = () => {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem("logout", Date.now());

    logout({ logoutParams: { returnTo: process.env.REACT_APP_LOGOUT_URL } });
  };

  const shouldDisplayModules = (permissions) => {
    const modulePermissions = [
      "Usuarios",
      "Doméstico",
      "Internacionales",
      "GCP",
      "Batch",
      "Vuelos",
      "Reporte Comat",
    ];
    return modulePermissions.some(
      (module) =>
        permissions.find((permission) => permission.name === module)?.access
    );
  };

  const shouldDisplayCatalogs = (permissions) => {
    const catalogPermissions = [
      "Fecha Métodos",
      "Tarifa promedio",
      "Batch vuelos",
      "Reporte vuelos",
      "Log vuelos",
      "Log Oracle",
      "Ventanas de mantenimiento",
    ];
    return catalogPermissions.some(
      (catalog) =>
        permissions.find((permission) => permission.name === catalog)?.access
    );
  };

  const shouldDisplayNotifications = (permissions) => {
    const notificationPermissions = [
      "Notificaciones - Dashboard",
      "Notificaciones - Servicios",
      "Notificaciones - SLA's",
    ];
    return notificationPermissions.some(
      (notification) =>
        permissions.find((permission) => permission.name === notification)
          ?.access
    );
  };

  if (!isAuthenticated && !isLoading)
    return (
      <>
        <SessionExpired />
      </>
    );

  if (isLoading || !hasFetchedData) return <Loading />;

  return (
    <div className="container-fluid p-0 m-0">
      {!showAlert ? (
        <>
          <MainBanner />
          <div className="d-flex">
            <div className="admin-menu">
              <div className="menu-icon-open-close" onClick={handleClick}>
                <img
                  src={click ? menuIconClicked : menuIcon}
                  alt={click ? "Closed Menu" : "Open Menu"}
                />
              </div>
              <div className={click ? "menu-admin active" : "menu-admin"}>
                <div className="d-flex flex-column">
                  <div className=" d-flex justify-content-center pb-2">
                    <img className="admin-profile-img" src={imgUser} alt="" />
                  </div>
                  <div className="text-premium-blue pb-2 pb-md-0">
                    <label className="menu-admin-item d-flex justify-content-center align-items-center">
                      Menú
                      <input
                        className="d-none"
                        type="checkbox"
                        checked={isCheckboxCollapseOpen}
                        onChange={onChange}
                      />
                      {isCheckboxCollapseOpen ? (
                        <IoIosArrowUp className="fs-9" />
                      ) : (
                        <IoIosArrowDown className="fs-9" />
                      )}
                    </label>
                    <Collapse isOpened={isCheckboxCollapseOpen}>
                      {/* <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("")}
                      >
                        <FaUserCog className="fs-5" />
                        <a className="text-premium-blue text-decoration-none px-2">
                          Perfil
                        </a>
                      </div>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("")}
                      >
                        <FaCog className="fs-5" />
                        <a className="text-premium-blue text-decoration-none px-2">
                          Configuración
                        </a>
                      </div>
                      <div className="menu-admin-item flex-column">
                        <FaLightbulb className="fs-5" />
                        <a
                          className="text-premium-blue text-decoration-none px-2"
                          href={pdfQuickReference}
                          download
                        >
                          Quick Reference
                        </a>
                      </div> */}
                      <div
                        className="menu-admin-item flex-column"
                        onClick={logoutAdmin}
                      >
                        <FaSignOutAlt className="fs-5" />
                        <a className="text-premium-blue text-decoration-none px-2">
                          Cerrar Sesión
                        </a>
                      </div>
                    </Collapse>
                  </div>
                </div>
                {shouldDisplayModules(permissions) && (
                  <div className="p-2">
                    <p className="micro-title font-semibold mb-0 text-mexican-pink">
                      Módulos
                    </p>
                  </div>
                )}
                {/* Usuarios */}
                {permissions.filter(
                  (permission) => permission.name === "Usuarios"
                )[0]?.access === true ? (
                  <div className="text-premium-blue pb-2 pb-md-0">
                    <label className="menu-admin-item d-flex align-items-center">
                      <FaUserCheck className="fs-5" />
                      <a className="text-premium-blue text-decoration-none px-2">
                        Usuarios
                      </a>
                      <input
                        className="d-none"
                        type="checkbox"
                        checked={isCheckboxCollapseOpen1}
                        onChange={onChange1}
                      />
                      {isCheckboxCollapseOpen1 ? (
                        <IoIosArrowUp className="fs-9 ms-auto" />
                      ) : (
                        <IoIosArrowDown className="fs-9 ms-auto" />
                      )}
                    </label>
                    <Collapse isOpened={isCheckboxCollapseOpen1}>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("Usuarios")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Lista de Usuarios
                        </a>
                      </div>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("AddUser")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Agregar Usuario
                        </a>
                      </div>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("deleteUser")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Restaurar Usuario
                        </a>
                      </div>
                    </Collapse>
                  </div>
                ) : (
                  ""
                )}
                {/* domestico */}
                {permissions.filter(
                  (permission) => permission.name === "Doméstico"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("Domestico")}
                    >
                      <RiFlightTakeoffLine className="fs-5" />
                      <p className="ps-2 m-0">Doméstico</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* internacionales */}
                {permissions.filter(
                  (permission) => permission.name === "Internacionales"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("Internacionales")}
                    >
                      <PiAirplaneInFlightFill className="fs-5" />
                      <p className="ps-2 m-0">Internacionales</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* GCP */}
                {/* {permissions.filter(
                  (permission) => permission.name === "GCP"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("GCP")}
                    >
                      <FaFileCode className="fs-5" />
                      <p className="ps-2 m-0">GCP</p>
                    </div>
                  </div>
                ) : (
                  ""
                )} */}
                {/* Batch */}
                {permissions.filter(
                  (permission) => permission.name === "Batch"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("Batch")}
                    >
                      <PiArrowsClockwiseBold className="fs-5" />
                      <p className="ps-2 m-0">Batch</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* Vuelos */}
                {permissions.filter(
                  (permission) => permission.name === "Vuelos"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("Vuelos")}
                    >
                      <IoAirplane className="fs-5" />
                      <p className="ps-2 m-0">Vuelos</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* Reporte Comat */}
                {permissions.filter(
                  (permission) => permission.name === "Reporte Comat"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("Comat")}
                    >
                      <PiNotePencilBold className="fs-5" />
                      <p className="ps-2 m-0">Reporte Comat</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {shouldDisplayCatalogs(permissions) && (
                  <div className="p-2 mt-3">
                    <p className="micro-title font-semibold mb-0 text-mexican-pink">
                      Catálogos
                    </p>
                  </div>
                )}
                {/* Fechas Métodos */}
                {permissions.filter(
                  (permission) => permission.name === "Fecha Métodos"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("FechaMetodos")}
                    >
                      <RiCalendarEventFill className="fs-4" />
                      <p className="ps-2 m-0">Fecha Métodos</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* Tarifas Promedio */}
                {permissions.filter(
                  (permission) => permission.name === "Tarifa promedio"
                )[0]?.access === true ? (
                  <div className="text-premium-blue pb-2 pb-md-0">
                    <label className="menu-admin-item d-flex align-items-center">
                      <FaMoneyCheckAlt className="fs-5" />
                      <a className="text-premium-blue text-decoration-none px-2">
                        Tarifa Promedio
                      </a>
                      <input
                        className="d-none"
                        type="checkbox"
                        checked={isCheckboxCollapseOpen2}
                        onChange={onChange2}
                      />
                      {isCheckboxCollapseOpen2 ? (
                        <IoIosArrowUp className="fs-9 ms-auto" />
                      ) : (
                        <IoIosArrowDown className="fs-9 ms-auto" />
                      )}
                    </label>
                    <Collapse isOpened={isCheckboxCollapseOpen2}>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("Tarifas")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Lista de Tarifas Promedio
                        </a>
                      </div>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("AddTarifas")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Agregar Tarifa Promedio
                        </a>
                      </div>
                    </Collapse>
                  </div>
                ) : (
                  ""
                )}
                {/* Batch Vuelos */}
                {permissions.filter(
                  (permission) => permission.name === "Batch vuelos"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("BatchVuelos")}
                    >
                      <PiArrowsClockwiseBold className="fs-5" />
                      <p className="ps-2 m-0">Batch Vuelos</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* Reporte Vuelos */}
                {permissions.filter(
                  (permission) => permission.name === "Reporte vuelos"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("ReporteVuelos")}
                    >
                      <PiArrowsClockwiseBold className="fs-5" />
                      <p className="ps-2 m-0">Reporte Vuelos</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* Log Vuelos */}
                {permissions.filter(
                  (permission) => permission.name === "Log vuelos"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("LogVuelos")}
                    >
                      <PiArrowsClockwiseBold className="fs-5" />
                      <p className="ps-2 m-0">Log Vuelos</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* Log Oracle */}
                {permissions.filter(
                  (permission) => permission.name === "Log Oracle"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("LogOracle")}
                    >
                      <PiClockCounterClockwiseBold className="fs-5" />
                      <p className="ps-2 m-0">Log Oracle</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* Vent. Mant. */}
                {permissions.filter(
                  (permission) =>
                    permission.name === "Ventanas de mantenimiento"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("VentMant")}
                    >
                      <FaWindows className="fs-5" />
                      <p className="ps-2 m-0">Vent. Mant.</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {shouldDisplayNotifications(permissions) && (
                  <div className="p-2 mt-3">
                    <p className="micro-title font-semibold mb-0 text-mexican-pink">
                      NOTIFICACIONES
                    </p>
                  </div>
                )}
                {/*Dashboard */}
                {permissions.filter(
                  (permission) =>
                    permission.name === "Notificaciones - Dashboard"
                )[0]?.access === true ? (
                  <div className="menu-admin-item">
                    <div
                      className="text-menu-item"
                      onClick={() => handleMenuClick("Dashboard")}
                    >
                      <FaProjectDiagram className="fs-5" />
                      <p className="ps-2 m-0">Dashboard</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* Servicios */}
                {permissions.filter(
                  (permission) =>
                    permission.name === "Notificaciones - Servicios"
                )[0]?.access === true ? (
                  <div className="text-premium-blue pb-2 pb-md-0">
                    <label className="menu-admin-item d-flex align-items-center">
                      <FaServer className="fs-5" />
                      <a className="text-premium-blue text-decoration-none px-2">
                        Servicios
                      </a>
                      <input
                        className="d-none"
                        type="checkbox"
                        checked={isCheckboxCollapseOpen3}
                        onChange={onChange3}
                      />
                      {isCheckboxCollapseOpen2 ? (
                        <IoIosArrowUp className="fs-9 ms-auto" />
                      ) : (
                        <IoIosArrowDown className="fs-9 ms-auto" />
                      )}
                    </label>
                    <Collapse isOpened={isCheckboxCollapseOpen3}>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("Servicios")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Lista de Servicios
                        </a>
                      </div>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("AddServicios")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Agregar Servicios
                        </a>
                      </div>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("RestoreServicios")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Restaurar Servicios
                        </a>
                      </div>
                    </Collapse>
                  </div>
                ) : (
                  ""
                )}
                {/* SLA's */}
                {permissions.filter(
                  (permission) => permission.name === "Notificaciones - SLA's"
                )[0]?.access === true ? (
                  <div className="text-premium-blue pb-2 pb-md-0">
                    <label className="menu-admin-item d-flex align-items-center">
                      <FaBalanceScale className="fs-5" />
                      <a className="text-premium-blue text-decoration-none px-2">
                        SLA's
                      </a>
                      <input
                        className="d-none"
                        type="checkbox"
                        checked={isCheckboxCollapseOpen4}
                        onChange={onChange4}
                      />
                      {isCheckboxCollapseOpen2 ? (
                        <IoIosArrowUp className="fs-9 ms-auto" />
                      ) : (
                        <IoIosArrowDown className="fs-9 ms-auto" />
                      )}
                    </label>
                    <Collapse isOpened={isCheckboxCollapseOpen4}>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("SLA")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Lista de SLA's
                        </a>
                      </div>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("AddSLA")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Agregar SLA's
                        </a>
                      </div>
                      <div
                        className="menu-admin-item flex-column"
                        onClick={() => handleMenuClick("RestoreSLA")}
                      >
                        <a className="text-premium-blue text-decoration-none px-2">
                          Restaurar SLA's
                        </a>
                      </div>
                    </Collapse>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="menu-item-content">
              <div className="main-panel">
                <div className="main-panel-name d-flex">
                  {getSectionIcon(selectedComponent)}
                  <p className="fw-bold ps-2 m-0 align-self-center">
                    {sectionNames[selectedComponent]}
                  </p>
                </div>
                <div className="main-panel-body">
                  {selectedComponent === "Usuarios" && (
                    <Usuarios updatePermisos={setPermissions} />
                  )}
                  {selectedComponent === "Domestico" && <Domestico />}
                  {selectedComponent === "Internacionales" && (
                    <Internacionales />
                  )}
                  {selectedComponent === "Comat" && <ReporteComat />}
                  {selectedComponent === "Vuelos" && <Vuelos />}
                  {selectedComponent === "BatchVuelos" && <BatchVuelos />}
                  {selectedComponent === "" && <Bienvenido />}
                  {selectedComponent === "AddUser" && (
                    <AddUser handleClick={handleMenuClick} />
                  )}
                  {selectedComponent === "deleteUser" && <UsuariosEliminado />}
                  {selectedComponent === "Batch" && <BatchCartaPorte />}
                  {selectedComponent === "FechaMetodos" && <FechaMetodos />}
                  {selectedComponent === "LogVuelos" && <LogVuelos />}
                  {selectedComponent === "ReporteVuelos" && <ReporteVuelos />}
                  {selectedComponent === "LogOracle" && <LogOracle />}
                  {selectedComponent === "VentMant" && <Maintenance />}
                  {selectedComponent === "Tarifas" && <TarifasPromedio />}
                  {selectedComponent === "AddTarifas" && (
                    <AddTarifas handleClick={handleMenuClick} />
                  )}
                  {selectedComponent === "SLA" && <SLA />}
                  {selectedComponent === "AddSLA" && (
                    <AddSlas handleClick={handleMenuClick} />
                  )}
                  {selectedComponent === "RestoreSLA" && (
                    <SlasEliminado handleClick={handleMenuClick} />
                  )}
                  {selectedComponent === "Servicios" && <Servicios />}
                  {selectedComponent === "AddServicios" && (
                    <AddServicio handleClick={handleMenuClick} />
                  )}
                  {selectedComponent === "RestoreServicios" && (
                    <RestoreServicio handleClick={handleMenuClick} />
                  )}
                  {selectedComponent === "Dashboard" && <Dashboard />}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <UserNotFound />
      )}
    </div>
  );
}

export default Admin;
